export enum FEED_ITEM_TYPE {
  PUBLICATION = 'publication',
  COMMUNITY_LEFT = 'community-left',
  COMMUNITY_JOINED = 'community-joined',
  COMMUNITY_SCHEDULED = 'community-scheduled',
  COMMUNITY_RESCHEDULED = 'community-rescheduled',
  WELCOME = 'welcome',
}
